"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCredentials = exports.postCredential = exports.deleteCredentialByUrl = exports.deleteCredentialById = exports.getCredentialByUrl = exports.getCredentialById = exports.putCredentialByUrl = exports.putCredentialById = void 0;
const credentials_1 = require("../models/credentials");
const shared_1 = require("../utils/shared");
const putCredentialById = async (accessToken, id, credential, options) => {
    var _a, _b;
    const client = (0, shared_1.getClientInstance)(options);
    const environment = (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : credentials_1.Environment.Production;
    const isUnencrypted = (_b = options === null || options === void 0 ? void 0 : options.isUnencrypted) !== null && _b !== void 0 ? _b : false;
    return client.put(`${environment}/v1/credentials/${id}`, credential, {
        params: {
            isUnencrypted,
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    }).then(response => response.data);
};
exports.putCredentialById = putCredentialById;
const putCredentialByUrl = async (accessToken, url, credential, options) => {
    const parsed = new URL(url);
    const splitPathname = parsed.pathname.split(/[/]+/);
    const id = splitPathname[splitPathname.length - 1];
    if (!id) {
        throw new Error(`Could not get the credential's ID. Invalid URL passed (${url})`);
    }
    return (0, exports.putCredentialById)(accessToken, id, credential, Object.assign(Object.assign({}, options), { environment: parsed.origin }));
};
exports.putCredentialByUrl = putCredentialByUrl;
const getCredentialById = async (accessToken, id, options) => {
    var _a;
    const client = (0, shared_1.getClientInstance)(options);
    const { decrypt } = options || {};
    const environment = (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : credentials_1.Environment.Production;
    // TODO check 404
    return client.get(`${environment}/v1/credentials/${id}`, {
        params: {
            decrypt,
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    }).then(response => { var _a; return (_a = response.data) !== null && _a !== void 0 ? _a : null; });
};
exports.getCredentialById = getCredentialById;
const getCredentialByUrl = async (accessToken, url, options) => {
    const parsed = new URL(url);
    const splitPathname = parsed.pathname.split(/[/]+/);
    const id = splitPathname[splitPathname.length - 1];
    if (!id) {
        throw new Error(`Could not extract the credential's ID. Invalid URL passed (${url})`);
    }
    return (0, exports.getCredentialById)(accessToken, id, Object.assign(Object.assign({}, options), { environment: parsed.origin }));
};
exports.getCredentialByUrl = getCredentialByUrl;
const deleteCredentialById = async (accessToken, id, options) => {
    var _a;
    const client = (0, shared_1.getClientInstance)(options);
    const environment = (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : credentials_1.Environment.Production;
    return client.delete(`${environment}/v1/credentials/${id}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    });
};
exports.deleteCredentialById = deleteCredentialById;
const deleteCredentialByUrl = async (accessToken, url, options) => {
    const parsed = new URL(url);
    const splitPathname = parsed.pathname.split(/[/]+/);
    const id = splitPathname[splitPathname.length - 1];
    if (!id) {
        throw new Error(`Could not extract the credential's ID. Invalid URL passed (${url})`);
    }
    return (0, exports.deleteCredentialById)(accessToken, id, Object.assign(Object.assign({}, options), { environment: parsed.origin }));
};
exports.deleteCredentialByUrl = deleteCredentialByUrl;
const postCredential = async (accessToken, credential, options) => {
    var _a;
    const client = (0, shared_1.getClientInstance)(options);
    const { isUnencrypted } = options || {};
    const environment = (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : credentials_1.Environment.Production;
    return client.post(`${environment}/v1/credentials/`, credential, {
        params: {
            isUnencrypted,
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    }).then(response => response.data);
};
exports.postCredential = postCredential;
const getCredentials = async (accessToken, options) => {
    var _a;
    const client = (0, shared_1.getClientInstance)(options);
    const { fulfillerId, operation, decrypt, limit, offset, } = options || {};
    const environment = (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : credentials_1.Environment.Production;
    return client.get(`${environment}/v1/credentials`, {
        params: {
            fulfillerId,
            operation,
            decrypt,
            limit,
            offset
        },
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    }).then(response => response.data);
};
exports.getCredentials = getCredentials;
